<script lang="ts">
export interface ProseLiProps {
  class?: any
}

export interface ProseLiSlots {
  default: (props?: object) => unknown
}
</script>

<script setup lang="ts">
const props = defineProps<ProseLiProps>()
defineSlots<ProseLiSlots>()
</script>

<template>
  <li
    class="my-0.5 ps-1.5"
    :class="props.class"
  >
    <slot />
  </li>
</template>
